var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Nombre")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Porcentaje")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Desde")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Hasta")]),
                  _vm._v(" "),
                  _c("th", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-success",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.agregarComision()
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-plus" })]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.form.comisiones, function(comision, key) {
                    return _c("tr", { key: key }, [
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  id: "nombre"[key],
                                  placeholder: "Escriba un nombre...",
                                  type: "text"
                                },
                                model: {
                                  value: comision.nombre,
                                  callback: function($$v) {
                                    _vm.$set(comision, "nombre", $$v)
                                  },
                                  expression: "comision.nombre"
                                }
                              },
                              [
                                _vm.errores.comisiones[key] != null &&
                                _vm.errores.comisiones[key].nombre != null
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.errores.comisiones[key].nombre
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.porcentaje,
                                  id: "porcentaje"[key],
                                  placeholder: "",
                                  type: "tel"
                                },
                                model: {
                                  value: comision.porcentaje,
                                  callback: function($$v) {
                                    _vm.$set(comision, "porcentaje", $$v)
                                  },
                                  expression: "comision.porcentaje"
                                }
                              },
                              [
                                _vm.errores.comisiones[key] != null &&
                                _vm.errores.comisiones[key].porcentaje != null
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.errores.comisiones[key]
                                                .porcentaje
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "valor_desde"[key],
                                  placeholder: "",
                                  type: "tel"
                                },
                                model: {
                                  value: comision.valor_desde,
                                  callback: function($$v) {
                                    _vm.$set(comision, "valor_desde", $$v)
                                  },
                                  expression: "comision.valor_desde"
                                }
                              },
                              [
                                _vm.errores.comisiones[key] != null &&
                                _vm.errores.comisiones[key].valor_desde != null
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.errores.comisiones[key]
                                                .valor_desde
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "valor_hasta"[key],
                                  placeholder: "",
                                  type: "tel"
                                },
                                model: {
                                  value: comision.valor_hasta,
                                  callback: function($$v) {
                                    _vm.$set(comision, "valor_hasta", $$v)
                                  },
                                  expression: "comision.valor_hasta"
                                }
                              },
                              [
                                _vm.errores.comisiones[key] != null &&
                                _vm.errores.comisiones[key].valor_hasta != null
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.errores.comisiones[key]
                                                .valor_hasta
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-danger",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.eliminarFila(key)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash" })]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.comisiones.length <= 0,
                          expression: "form.comisiones.length <= 0"
                        }
                      ]
                    },
                    [_vm._m(1)]
                  )
                ],
                2
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Utilidades")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "5" } }, [
      _c("strong", [_vm._v("No hay campos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-575dc141", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-575dc141","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/comisiones/ComisionUtilidad.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-575dc141","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/comisiones/ComisionUtilidad.vue
// module chunks = 0